// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router/index'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import VueElementExtends from 'vue-element-extends'
import 'vue-element-extends/lib/index.css'

import api from './api/index'
import store from './store/index'

Vue.config.productionTip = false
Vue.prototype.$api = api

Vue.use(ElementUI)
Vue.use(VueElementExtends)

// eslint-disable-next-line no-new
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js